import * as React from 'react';
import { useState, useEffect, useLayoutEffect } from 'react';

//Libs
import { useDispatch, useSelector } from 'react-redux';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

//Components
import Field from '../../../modules/metajson-sub/src/libs/controls/components/Field';

//Options & Config
import { options } from './gridConfigAndColumns';
import { dataAdapter } from './dataAdapter';
// import { GetPdfModal } from './modalTemplates/GetPdfModal';
import { SignDocModal } from './modalTemplates/SignDocModal';
import { getDocumentTable } from './actions';
import { HistoryModal } from './modalTemplates/HistoryModal';
import { documentDataElem } from './types';
import Alert from '../../../modules/metajson-sub/src/libs/controls/components/Alert';
import { useActionsHandlers } from './hooks/useActionsHandlers';

const SignGridComponent = ({
  schema,
  api,
  error,
  visited,
  dispatcher,
  opts,
  information,
  values,
  rowIndex,
  allSections,
}) => {
  const [state, form_type, process_id] = useSelector((state: any) => [
    state.SignGridComponentReducer,
    state.forms.form_type,
    state.forms.process_id,
  ]);

  const {
    documentData,
    rowId,
    isPDFModalOpen,
    isSignModalOpen,
    isHistoryModalOpen,
  } = state;

  const [fileTemplate, setFileTemplate] = useState(null);
  const [currentDocumentType, setCurrentDocumentType] = useState(null);

  const dispatch = useDispatch();
  const containerClass = 'react-bs-container-body_v1';

  const handleFileTemplate = (data: Array<documentDataElem>, id: string) =>
    data.find((row) => row.id === id)?.files[0];
  const handleDocumentType = (data: Array<documentDataElem>, id: string) =>
    data.find((row) => row.id === id)?.documentType;

  useLayoutEffect(() => {
    getDocumentTable(form_type, process_id)(dispatch);
  }, []);

  useEffect(() => {
    setFileTemplate(handleFileTemplate(documentData, rowId));
    setCurrentDocumentType(handleDocumentType(documentData, rowId));
  }, [documentData, rowId]);

  const { handleClick, pdfErrorMessage, isLoading } = useActionsHandlers({
    api,
    allSections,
  });

  const tableData = dataAdapter(documentData, handleClick, isLoading);

  return (
    <>
      <Field
        type={schema.type}
        title={schema.title}
        required={schema.required}
        id={schema.id}
        contentNumb={schema.contentNumb}
      >
        <BootstrapTable
          {...options.config}
          data={tableData}
          bodyContainerClass={containerClass}
          headerContainerClass={containerClass}
        >
          {options.columns.map((item) => (
            <TableHeaderColumn {...item} key={item.dataField}>
              {item.title}
            </TableHeaderColumn>
          ))}
        </BootstrapTable>
        {/* <GetPdfModal
          isOpen={isPDFModalOpen}
          api={api}
          allSections={allSections}
          currentDocumentType={currentDocumentType}
        /> */}
        <SignDocModal
          isOpen={isSignModalOpen}
          api={api}
          fileTemplate={fileTemplate}
        />
        <HistoryModal isOpen={isHistoryModalOpen} />
        {pdfErrorMessage ? <Alert>{pdfErrorMessage}</Alert> : null}
      </Field>
    </>
  );
};

export const createSignComponent = (
  schema: any,
  // TODO: abstract type any
  api: any,
  dispatcher: any,

  error: any,
  visited: boolean,
  // TODO: abstract type any
  opts?: any,
  // TODO: abstract type any
  information?: any,
  values?: Array<{ controlid: string; value: unknown }>,
  rowIndex?: number,
  allSections?: any,
): React.ReactElement<any> => {
  console.log("schema", schema, "api", api, "dispatcher", dispatcher, "opts", opts, "information", information, "values", values, "rowIndex", rowIndex, "allSections", allSections)
  return (
    <SignGridComponent
      schema={schema}
      api={api}
      error={error}
      visited={visited}
      dispatcher={dispatcher}
      opts={opts}
      information={information}
      values={values}
      rowIndex={rowIndex}
      allSections={allSections}
    />
  );
};
